import { DeviceProfile, ParseSnapshotProduct } from '@/types/pages/storeManagement/device';
import { getApiBaseUrl } from './env';
import noPreviewImage from '@/assets/images/no-preview.png';

const hasPreviewImage = (imgPath?: string | null): boolean => Boolean(imgPath && imgPath.trim() !== '');

const getPreviewUrl = (imgPath: string): string => {
    const API_BASE_URL = getApiBaseUrl();
    if (!hasPreviewImage(imgPath)) {
        return noPreviewImage;
    }

    return `${API_BASE_URL}${imgPath}`;
};

const getProfileSize = (profile?: DeviceProfile | null) => {
    const sizeMatch = profile?.size?.match(/^(\d+)x(\d+)$/);

    return {
        width: sizeMatch ? Number(sizeMatch[1]) : 250,
        height: sizeMatch ? Number(sizeMatch[2]) : 250,
    };
};

const parseShelfCodes = (value?: string): string[] => {
    if (!value) return [];

    return value
        .split('|||')
        .map((item) => item.replace(/###[^#]+###-.*$/, '').trim())
        .filter(Boolean);
};

const parseCampaignCodes = (value?: string): string[] => {
    if (!value) return [];

    const parts = value.trim().split(/[\\/]/).filter(Boolean);
    const filename = parts[parts.length - 1];

    return filename ? [filename] : [];
};

const driverProductSnapshotInfo = (snapshot: string | null) => {
    if (!snapshot) return [];

    try {
        const parsed = JSON.parse(snapshot) as ParseSnapshotProduct[];
        return parsed.map((o) => {
            const fields = o.p_custom.split(',');
            return {
                barcode: o.p_barcode,
                shelfCodes: parseShelfCodes(fields[91]),
                campaignCodes: parseCampaignCodes(fields[92]),
            };
        });
    } catch {
        return [];
    }
};
const formatInitiator = (initiator?: string) => {
    if (!initiator) return '-';

    const parts = initiator.split('|');

    return parts.length > 1 ? parts.slice(1).join('|') : parts[0];
};

export { getPreviewUrl, getProfileSize, driverProductSnapshotInfo, formatInitiator, hasPreviewImage };
